import naturalSort from "natural-order/lib/natural-sort";

export const compareNatural = naturalSort();

export function compareNaturalBy(getValue) {
  return (a, b) => compareNatural(getValue(a) || "", getValue(b) || "");
}
